import { render, staticRenderFns } from "./FixedCostDetails.vue?vue&type=template&id=627621a4&scoped=true&"
import script from "./FixedCostDetails.vue?vue&type=script&lang=js&"
export * from "./FixedCostDetails.vue?vue&type=script&lang=js&"
import style0 from "./FixedCostDetails.vue?vue&type=style&index=0&id=627621a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627621a4",
  null
  
)

export default component.exports